import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Dashboard from "../../layouts/Dashboard";
import { Text, Icons, IconButton } from "@pushpress/shared-components";

import styles from "./CommittedClub.module.scss";
import { BadgeTemplate } from "@pushpress/committed-club-typescript-sdk";
import CommittedClubPreLaunch from "./CommittedClubPreLaunch";
import CommittedClubPostLaunch from "./CommittedClubPostLaunch";
import { useHistory } from "react-router-dom";
import { useAnalytics } from "../../components/providers/AnalyticsProvider";
import { CommittedClubEvent } from "./CommittedClubEvents";

type CommittedClubHomeProps = {
  badgeTemplate?: BadgeTemplate;
  refetchBadgeTemplate: () => Promise<void>;
};

const CommittedClubHome = (props: CommittedClubHomeProps) => {
  const { badgeTemplate, refetchBadgeTemplate } = props;

  const [isLaunched, setIsLaunched] = useState(false);

  const history = useHistory();

  const { trackEvent } = useAnalytics();

  useEffect(() => {
    const determineLaunchStatus = () => {
      if (badgeTemplate) {
        const hasClubLaunched = new Date() >= new Date(badgeTemplate.startTime);
        setIsLaunched(hasClubLaunched);
      } else {
        setIsLaunched(false);
      }
    };

    determineLaunchStatus();
  }, [badgeTemplate]);

  const navigateToSettings = useCallback(() => {
    trackEvent(CommittedClubEvent.SettingsSelected, {
      page: "committed_club_dashboard",
      live_now: true,
      state: "launched",
      app: "committed_club",
    });

    history.push("/committed-club/settings");
  }, [history, trackEvent]);

  return (
    <>
      <Helmet>
        <title>Committed Club</title>
      </Helmet>
      <Dashboard scrollableContent disableContentPadding>
        <div className={styles.container}>
          <div className="tw-flex tw-items-center tw-justify-between">
            <Text weight="600" variant="heading-3" color="black">
              Committed Club
            </Text>
            {isLaunched && (
              <IconButton
                active
                icon={Icons.NavIconSettings}
                tooltip="Settings"
                onClick={navigateToSettings}
              />
            )}
          </div>

          {isLaunched ? (
            <CommittedClubPostLaunch badgeTemplate={badgeTemplate} />
          ) : (
            <CommittedClubPreLaunch
              badgeTemplate={badgeTemplate}
              refetchBadgeTemplate={refetchBadgeTemplate}
            />
          )}
        </div>
      </Dashboard>
    </>
  );
};

export default CommittedClubHome;
